// action.js
import {
  SERVICE_SETTINGS_FETCH_ACTION,
  SERVICE_SETTINGS_FETCH_SUCCESS,
  SERVICE_SETTINGS_FETCH_ERROR,
  SERVICE_SETTINGS_SAVE_ACTION,
  SERVICE_SETTINGS_SAVE_SUCCESS,
  SERVICE_SETTINGS_SAVE_ERROR
} from "./actionType";



export const ServiceSettings_Fetch_Action = (config) => ({
  type: SERVICE_SETTINGS_FETCH_ACTION,
  config, // config expected to contain { id }
});

export const ServiceSettings_Fetch_Success = (resp) => ({
  type: SERVICE_SETTINGS_FETCH_SUCCESS,
  payload: resp,
});

export const ServiceSettings_Fetch_Error = (resp) => ({
  type: SERVICE_SETTINGS_FETCH_ERROR,
  payload: resp,
});

export const ServiceSettings_Save_Action = (config) => ({
  type: SERVICE_SETTINGS_SAVE_ACTION,
  config,
});

export const ServiceSettings_Save_Success = (resp) => ({
  type: SERVICE_SETTINGS_SAVE_SUCCESS,
  payload: resp,
});

export const ServiceSettings_Save_Error = (resp) => ({
  type: SERVICE_SETTINGS_SAVE_ERROR,
  payload: resp,
});
